import { useTranslation } from 'react-i18next'
import { mapRejectionToMessage as mapRejectionToMessageDefault } from './DeleteErrors'
import DeleteModalContainer, { IDeleteModalContainerProps } from '@cbgms/components/form/Dialogs/DeleteModalContainer'

interface Props extends Omit<IDeleteModalContainerProps, 'mapApiResponseToMessage' | 'item' | 'isPortal'> {
  translationKey: string
  mapRejectionToMessage?: IDeleteModalContainerProps['mapApiResponseToMessage'] // This can be removed when ListWrapper is refactored
}

function SupportDeleteModalContainer({ translationKey, mapRejectionToMessage, ...rest }: Props) {
  const { t } = useTranslation()

  const item = t(`error.delete.delete_item_${translationKey}`)
  const mapApiResponseToMessage = mapRejectionToMessage || mapRejectionToMessageDefault

  return <DeleteModalContainer {...rest} isPortal={false} item={item} mapApiResponseToMessage={mapApiResponseToMessage} />
}

export default SupportDeleteModalContainer
